module.exports = __webpack_public_path__ + "img/Packaging.a7af171f.png";